import { BaseController } from '../../../../common/base/controller';

export class AdviserFormController extends BaseController {
  constructor(controllerService, ticketsDataService) {
    'ngInject';
    super({ controllerService, ticketsDataService });
  }
}
